import { FormattedRelyingPartyConfig } from "@idw-types/data/relying-party-config";

export enum RelyingPartyDetailsActionTypes {
    // Relying Party Details
    SET_RELYING_PARTY_DETAILS_LOADING = "SET_RELYING_PARTY_DETAILS_LOADING",
    SET_RELYING_PARTY_DETAILS = "SET_RELYING_PARTY_DETAILS"
}

type SetRelyingPartyDetailsLoadingAction = {
    type: RelyingPartyDetailsActionTypes.SET_RELYING_PARTY_DETAILS_LOADING;
    payload: { isLoading: boolean; }
};

export const setRelyingPartyDetailsLoading = (isLoading: boolean): SetRelyingPartyDetailsLoadingAction => ({
    type: RelyingPartyDetailsActionTypes.SET_RELYING_PARTY_DETAILS_LOADING,
    payload: { isLoading }
});

type SetRelyingPartyDetailsAction = {
    type: RelyingPartyDetailsActionTypes.SET_RELYING_PARTY_DETAILS;
    payload: { relyingParty: FormattedRelyingPartyConfig; }
}

export const setRelyingPartyDetails = (relyingParty: FormattedRelyingPartyConfig): SetRelyingPartyDetailsAction => ({
    type: RelyingPartyDetailsActionTypes.SET_RELYING_PARTY_DETAILS,
    payload: { relyingParty }
});

export type RelyingPartyDetailsActions =
    SetRelyingPartyDetailsLoadingAction |
    SetRelyingPartyDetailsAction